import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllSchools as apiForceDeleteAllSchools } from "../../api/apiSchools";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllSchools() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAllSchools, isPending: isForceDelete, data: results, error } = useMutation({
        mutationFn: (req) => apiForceDeleteAllSchools(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["schools"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAllSchools, isForceDelete, error, results };
}
